import { getRenters } from "@/common/services/renters.api";
import { getPartnersFiltered } from "@/common/services/partners.api";
import { getVehicles } from "@/common/services/vehicles.api";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { emptyDevolutionDeposit, IDevolutionDeposit } from "@/types/devolution-deposit";
import { IRenter } from "@/types/renter.type";
import { IVehicle, PartnerInfoType } from "@/types/vehicle.type";


type Props = {
  onSave: (formData: Partial<IDevolutionDeposit>) => void;
  onCancel: () => void;
};

export default function FormCreateReturnofdeposit({ onSave, onCancel }: Props) {
  const [renters, setRenters] = useState<IRenter[]>([]);
  const [partners, setPartners] = useState<PartnerInfoType[]>([]);
  const [vehicles, setVehicles] = useState<IVehicle[]>([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<Partial<IDevolutionDeposit>>(emptyDevolutionDeposit);

  useEffect(() => {
    async function fetchRenters() {
      setLoading(true);
      try {
        const response = await getRenters({ itemsPerPage: "9999" });
        if (response?.data) setRenters(response.data);
      } catch (error) {
        console.error("Erro ao carregar clientes:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchRenters();
  }, []);

  useEffect(() => {
    async function fetchPartners() {
      try {
        const response = await getPartnersFiltered({ companyId: "*" });
        if (response?.data) setPartners(response.data);
      } catch (error) {
        console.error("Erro ao carregar parceiros:", error);
      }
    }
    fetchPartners();
  }, []);

  useEffect(() => {
    async function fetchVehicles(partnerId: string) {
      if (!partnerId) return;
      setLoading(true);
      try {
        const response = await getVehicles({ itemsPerPage: "9999", partnerId });
        if (response?.data) {
          setVehicles(response.data);
        }
      } catch (error) {
        console.error("Erro ao carregar motos:", error);
      } finally {
        setLoading(false);
      }
    }
    if (formData.partnerId) fetchVehicles(formData.partnerId);
  }, [formData.partnerId]);




  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const filteredVehicles = vehicles

  return (
    <form onSubmit={handleSubmit} className="space-y-4 rounded-lg">
      <div>
        <label className="block text-sm font-medium">Cliente</label>
        <Select
          options={renters.map((r) => ({
            value: r._id,
            label: `${r.name} - ${r.cpf}`,
          }))}
          value={
            renters.find((r) => r._id === formData.renterId)
              ? {
                value: formData.renterId,
                label: `${renters.find((r) => r._id === formData.renterId)?.name} - ${renters.find((r) => r._id === formData.renterId)?.cpf}`,
              }
              : null
          }
          onChange={(selected) =>
            setFormData((prev) => ({
              ...prev,
              renterId: selected?.value || "",
              name: selected?.label.split(" - ")[0] || "",
            }))
          }
          placeholder={loading ? "Carregando..." : "Selecione ou pesquise um cliente"}
          isClearable
          className="w-full"
          styles={{
            control: (base) => ({
              ...base,
              borderRadius: "0.5rem",
              padding: "2px",
            }),
          }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Selecione um parceiro</label>
        <Select
          options={partners.map((p) => ({
            value: p._id,
            label: p.companyName,
          }))}
          value={
            partners.find((p) => p._id === formData.partnerId)
              ? {
                value: formData.partnerId,
                label: partners.find((p) => p._id === formData.partnerId)?.companyName,
              }
              : null
          }
          onChange={(selected) =>
            setFormData((prev) => ({
              ...prev,
              partnerId: selected?.value || "",
              partnerCompanyName: selected?.label || "",
              licensePlate: "",
            }))
          }
          placeholder="Selecione ou pesquise um parceiro"
          isClearable
          className="w-full"
          styles={{
            control: (base) => ({
              ...base,
              borderRadius: "0.5rem",
              padding: "2px",
            }),
          }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Placa</label>
        <Select
          options={filteredVehicles.map((v) => ({
            value: v.licensePlate,
            label: `${v.licensePlate} - ${v.model}`,
          }))}
          value={
            formData.licensePlate
              ? {
                value: formData.licensePlate,
                label: `${formData.licensePlate} - ${filteredVehicles.find((v) => v.licensePlate === formData.licensePlate)?.model || ""
                  }`,
              }
              : null
          }
          onChange={(selected) =>
            setFormData((prev) => ({
              ...prev,
              licensePlate: selected?.value || "",
            }))
          }
          placeholder="Selecione ou pesquise uma placa"
          isDisabled={!formData.partnerId}
          isClearable
          className="w-full"
          styles={{
            control: (base) => ({
              ...base,
              borderRadius: "0.5rem",
              padding: "2px",
            }),
          }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Plano</label>
        <input
          type="text"
          name="plan"
          value={formData.plan || ""}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-lg"
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Data de Locação</label>
        <input
          type="date"
          name="dateLocation"
          value={formData.dateLocation?.toString() || ""}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-lg"
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Data de devolução do veículo</label>
        <input
          type="date"
          name="dateDevolution"
          value={formData.dateDevolution?.toString() || ""}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border rounded-lg"
        />
      </div>

      <div>
        <label className="block text-sm font-medium">Data de devolução do caução</label>
        <input
          type="date"
          name="dateDevolutionDeposit"
          value={formData.dateDevolutionDeposit?.toString() || ""}
          onChange={handleChange}
          required
          className="w-full px-3 py-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium">Valor</label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            R$
          </span>
          <input
            type="text"
            name="valueDeposit"
            value={formData.valueDeposit ? new Intl.NumberFormat('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(Number(formData.valueDeposit)) : ""}
            onChange={(e) => {
              const rawValue = e.target.value.replace(/\D/g, '');
              const numericValue = Number(rawValue) / 100;
              setFormData((prev) => ({
                ...prev,
                valueDeposit: numericValue,
              }));
            }}
            placeholder="0,00"
            className="w-full pl-10 pr-3 py-2 border rounded-lg"
          />
        </div>
      </div>
      {/* Botões */}
      <div className="flex justify-end space-x-2 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-locavibe text-white rounded-lg hover:bg-red-700"
        >
          Salvar
        </button>
      </div>
    </form>
  );
}
